import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Formik } from "formik";
import InputWrapper from "./InputWrapper";
import ButtonWrapper from "./ButtonWrapper";
import SelectWrapper from "./SelectWrapper";
import { useNavigate, useParams } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import postQrInitManualTransaction, {
  postIdrCreateTransaction,
} from "../redux/actions/postQrInitManual";
import * as Yup from "yup";
import { bankNames, toLocaleStringFormate } from "../helpingFunctions";
import { language } from "../utils/language";
import MainWrapper from "./MainWrapper";
import WarningModal from "./WarningModal";
import { Fade, Reveal, Slide } from "react-awesome-reveal";
import getVerifyManualTransaction, {
  getVerifyManualTransactionIdr,
} from "../redux/actions/getVerifyManualTransaction";
import PapayaLogo from "../assets/PAPAYA_LOGO.svg";
import { Slider } from "antd";

const CardWrapper = styled.div`
  height: auto;
  @media (min-width: 280px) and (max-width: 768px) {
    width: 90%;
  }
  width: 100%;
  background: #fff;
  /* padding: 20px 10px; */
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border-radius: 10px;
  .card-header {
    background: #162056;
    padding: 20px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
  h3 {
    color: white;
  }
  p {
    font-size: 16px;
  }
`;

const IdrMethodTransactionInfoCard = (props) => {
  const params = useParams();
  const dispatch = useDispatch();
  const navigation = useNavigate();

  const { data } = useSelector(
    (state) => state.getVerifyManualTransactionReducer
  );
  const { modalShow, modalData } = useSelector(
    (state) => state.warningModalReducer
  ); //Warning modal data

  const { isLoading } = useSelector((state) => state.postQrInitManualReducer);

  // -----checking link is verify or not---------
  const { error } = useSelector(
    (state) => state.getVerifyManualTransactionReducer
  );

  const handleProceedFunc = () => {
    let qrManualTransactionParams = {
      transactionId: data.trxRef,
      type: "qris",
      amount: parseFloat(data?.amount),
      sessionId: data.sessionToken,
      userId: data.merchantId,
    };
    dispatch(
      postIdrCreateTransaction(qrManualTransactionParams, navigation, params.id)
    );
  };

  // useEffect(() => {
  //   if (error) {
  //     navigate(`/idr/${params.id}`);
  //   }
  // }, [error]);

  return (
    <Slide className="d-flex justify-content-center align-items-center">
      {/* <WarningModal
        visible={modalShow}
        lang={props.lang}
        closeIcon={<span></span>}
        maskClosable={false}
        // centered={true}
        footer={null}
        bodyStyle={{ borderRadius: 10 }}
        width={370}
      /> */}
      <CardWrapper>
        <div className="card-header w-100">
          <h3 className="text-center" style={{ color: "#fff" }}>
            Transaction Information
          </h3>
        </div>
        <div className="w-100 p-4">
          <div className=" d-flex align-items-center justify-content-between">
            <div className="w-75">
              <p className="label mb-0 mt-3">
                Transaction REF: <strong>{data?.trxRef}</strong>
              </p>
              <p className="label mb-0 mt-3">
                AMOUNT (Rp):{" "}
                <strong>{toLocaleStringFormate(data?.amount)}</strong>
              </p>
            </div>
            <img
              src={PapayaLogo}
              width={50}
              height={50}
              className="w-25 d-flex justify-content-center"
            />
          </div>
          <div className="w-100">
            <ButtonWrapper
              border={true}
              size="middle"
              height="40px"
              htmlType="submit"
              className="w-100 mt-4"
              text="Proceed to Payment"
              loading={isLoading}
              onClick={() => handleProceedFunc()}
            />
          </div>
        </div>
      </CardWrapper>
    </Slide>
  );
};

export default IdrMethodTransactionInfoCard;
